import { Circle } from '@mui/icons-material'
import { Tooltip, useTheme } from '@mui/material'
import { AssetType } from '../enums/AssetType'
import { Asset } from '../types'
import DeviceStatusIndicator from './DeviceStatusIndicator'
import RuuviTagStatusIndicator from './RuuviTagStatusIndicator'
import { AssetStatus } from '../types/Asset'
import { useTranslation } from 'react-i18next'

/**
 * The props of the asset status indicator.
 */
interface AssetStatusIndicatorProps {
  /**
   * The asset.
   */
  asset: Asset

  /**
   * The font size.
   */
  fontSize?: 'inherit' | 'small' | 'medium' | 'large'
}

/**
 * An indicator for the asset status.
 */
export default function AssetStatusIndicator({
  asset,
  fontSize = 'inherit'
}: AssetStatusIndicatorProps): JSX.Element {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The theme.
   */
  const theme = useTheme()

  return (
    <>
      {asset.status === AssetStatus.INACTIVE ? (
        <Tooltip title={t('detached') as string}>
          <Circle color="disabled" fontSize={fontSize} />
        </Tooltip>
      ) : asset.type === AssetType.DEVICE && asset.device ? (
        <DeviceStatusIndicator device={asset.device} fontSize={fontSize} />
      ) : asset.type === AssetType.RUUVI_TAG && asset.ruuviTag ? (
        <RuuviTagStatusIndicator ruuviTag={asset.ruuviTag} fontSize={fontSize} />
      ) : (
        <Circle fontSize={fontSize} sx={{ color: theme.palette.text.secondary }} />
      )}
    </>
  )
}
